import { ApiError, beablooApi } from '../../utils';

const setHome = () => {
  return async (dispatch, getState) => {
    const { general } = getState();

    const response = await beablooApi({
      method: 'GET',
      route: `/developments/${general.currentDevelopment.id}/pages/home`,
    })
      .then((r) => r.data)
      .catch((e) => {
        throw new ApiError('failed to get home', []);
      });

    dispatch({
      type: 'SET_HOME',
      data: response,
    });
  };
};

export { setHome };
